import React, { useState } from 'react';
import styled from 'styled-components';

import { WindowDropDowns } from 'components';
import dropDownData from '../Notepad/dropDownData';

const defaultPasswords = `===========================================
  PASSWORDS - DO NOT DELETE!!!
  Last updated: 14/03/2004
===========================================

Email (Outlook)
  username: rhys.ellis@ellisandco.co.uk
  password: RhysEllis1993!

Bank (NatWest Business)
  username: rhys.ellis@ellisandco.co.uk
  password: RhysEllis1993!

Amazon
  username: rhys.ellis@ellisandco.co.uk
  password: RhysEllis1993!

eBay
  username: rhys_ellis_93
  password: RhysEllis1993!

Hotmail (personal)
  username: rhys_ellis_93@hotmail.com
  password: RhysEllis1993!

Facebook
  username: rhys.ellis@ellisandco.co.uk
  password: RhysEllis1993!

WiFi Router (BT Hub)
  password: the one on the sticker

Companies House
  username: rellis
  password: RhysEllis1993

HMRC Government Gateway
  username: can't remember
  password: tried RhysEllis1993! but locked out

Sage Accounting
  username: ???
  password: ???
  NOTE: think Sarah set this up before she left

MSN Messenger
  username: rhys_ellis_93@hotmail.com
  password: RhysEllis1993!
  display name: ~*~Rhys from Accounts~*~

Friends Reunited
  username: rhys_ellis_93@hotmail.com
  password: RhysEllis1993!

Kazaa
  username: djrhys93
  password: RhysEllis1993!

-------------------------------------------
TODO: must change these passwords soon
TODO: set up that two-factor thing Gary mentioned
TODO: ask Dead Simple Computing about security
TODO: Gary says Norton has expired but the
      icon is still there so its probably fine
-------------------------------------------
`;

export default function PasswordsNotepad({ onClose }) {
  const [docText, setDocText] = useState(defaultPasswords);
  const [wordWrap, setWordWrap] = useState(true);

  function onClickOptionItem(item) {
    switch (item) {
      case 'Exit':
        onClose();
        break;
      case 'Word Wrap':
        setWordWrap(!wordWrap);
        break;
      default:
    }
  }

  return (
    <Div>
      <section className="np__toolbar">
        <WindowDropDowns items={dropDownData} onClickItem={onClickOptionItem} />
      </section>
      <StyledTextarea
        wordWrap={wordWrap}
        value={docText}
        onChange={e => setDocText(e.target.value)}
        spellCheck={false}
      />
    </Div>
  );
}

const Div = styled.div`
  height: 100%;
  background: linear-gradient(to right, #edede5 0%, #ede8cd 100%);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  .np__toolbar {
    position: relative;
    height: 21px;
    flex-shrink: 0;
    border-bottom: 1px solid white;
  }
`;

const StyledTextarea = styled.textarea`
  flex: auto;
  outline: none;
  font-family: 'Lucida Console', monospace;
  font-size: 13px;
  line-height: 14px;
  resize: none;
  padding: 2px;
  ${props => (props.wordWrap ? '' : 'white-space: nowrap; overflow-x: scroll;')}
  overflow-y: scroll;
  border: 1px solid #96abff;
`;
